import { merge } from 'lodash';
import Papa from 'papaparse';

type BaseData = {
  [key: string]: unknown;
};

interface ExportDataToCsvConfig<TData extends BaseData> {
  /**
   * Rename array for replacing columns names based on the field selector.
   * It can fully or partially override the selected fields.
   */
  columnsNames?: string[];
  /**
   * An array of keys to pick from the data attributes.
   */
  fieldsSelector: (keyof TData)[];
  /**
   * Data to export to csv.
   */
  data: TData[];
}

const exportDataToCsv = <TData extends BaseData>(
  config: ExportDataToCsvConfig<TData>,
) => {
  const { columnsNames, fieldsSelector, data } = config;

  const csv = Papa.unparse(
    {
      data,
      fields: fieldsSelector as string[],
    },
    {
      // omits the original headers based on the column names
      header: false,
    },
  );

  // Generates the headers based on the column rename array
  const headers = Papa.unparse({
    data: [],
    fields: merge(fieldsSelector, columnsNames),
  });

  return new Blob([headers.concat(csv)], { type: 'text/csv' });
};

export default exportDataToCsv;
